import { SEC_TYPE } from 'const/stock'
import { ORDER_TYPE } from 'const/trade'
import setOptionRequestParams from 'utils/setOptionRequestParams'

/**
 * 转换本地订单数据为接口数据格式（格式化后的数据仅用于接口请求）
 * FIXME: 暂时不支持跟踪单
 * @param { Object } order
 * @param { Boolean } isIb
 * @param [market, symbol, secType, strike, right, expiry ]
 * @param order.action 买卖方向
 * @param order.orderType 订单类型
 * @param order.outsideRth 允许延长时段交易
 * @param order.timeInForce 当日有效
 * @param order.quantity 订单数量
 * @param order.limitPrice 限价
 * @param order.stpPrice 止损价
 */

function getExchange(market) {
  const exchanges = {
    US: 'SMART',
    HK: 'SEHK',
    SH: 'SEHKNTL',
    SZ: 'SEHKSZSE'
  }
  return exchanges[market]
}

export default function formatOrderLocalToServeParams(order, isIb) {
  const params = {
    action: order.action,
    symbol: order.symbol,
    market: order.market,
    currency: order.currency,
    source: 'desktop-web'
  }
  if (isIb) {
    if (order.orderId) params.orderId = order.orderId
    params.secType = order.secType
    params.orderType = order.orderType
    params.localSymbol = order.symbol
    params.timeInForce = order.timeInForce
    params.outsideRth = order.outsideRth
    // 限价和限价止损单需要限制价格
    if ([ORDER_TYPE.LMT, ORDER_TYPE.STP_LMT].includes(order.orderType)) {
      params.limitPrice = order.limitPrice
    }
    if ([ORDER_TYPE.STP, ORDER_TYPE.STP_LMT].includes(order.orderType)) {
      params.auxPrice = order.stpPrice
    }
    if (ORDER_TYPE.TRAIL_1 === order.orderType) {
      params.orderType = ORDER_TYPE.TRAIL
      params.trailingPercent = order.trailingPercent
    }
    if (ORDER_TYPE.TRAIL_2 === order.orderType) {
      params.orderType = ORDER_TYPE.TRAIL
      params.auxPrice = order.trailingPrice
    }
    params.exchange = getExchange(order.market)
    params.totalQuantity = order.totalQuantity || order.quantity

    // 附加单只能存在限价单下
    if (
      ORDER_TYPE.LMT === order.orderType &&
      [ORDER_TYPE.PROFIT, ORDER_TYPE.BRACKETS].includes(order.attachOrderType)
    ) {
      params.profitTakerPrice = order.profitTakerPrice
      params.profitTakerTif = order.profitTakerTif
      params.profitTakerRth = order.profitTakerRth
    }
    if (
      ORDER_TYPE.LMT === order.orderType &&
      [ORDER_TYPE.LOSS, ORDER_TYPE.BRACKETS].includes(order.attachOrderType)
    ) {
      params.stopLossPrice = order.stopLossPrice
      params.stopLossTif = order.stopLossTif
      params.stopLossRth = order.stopLossRth
    }
  } else {
    params.sec_type = order.secType
    params.order_type = order.orderType
    params.quantity = order.totalQuantity || order.quantity
    params.only_rth = !order.outsideRth
    params.time_in_force = order.timeInForce
    if (order.orderId) params.id = order.orderId

    // 标准账户需要设置 external_id 用户区分订单
    params.external_id = new Date().getTime()
    // 限价和限价止损单需要限制价格
    if ([ORDER_TYPE.LMT, ORDER_TYPE.STP_LMT].includes(order.orderType)) {
      params.price = order.limitPrice
    }
    // 止损单和限价止损单需要止损价格
    if ([ORDER_TYPE.STP, ORDER_TYPE.STP_LMT].includes(order.orderType)) {
      params.stop_price = order.stpPrice
    }
  }

  // 期权需要传相关信息
  if (order.secType === SEC_TYPE.OPT) {
    setOptionRequestParams(params, order)
    params.multiplier = order.multiplier
  }

  return params
}
